import React, { FC } from 'react';
import AngleButton from '../AngleButton';
import OrangeDivider from '../OrangeDivider';

const BestPractices: FC = () => {
  return (
    <div className='w-full mt-16 text-left sm:mt-24 md:grid md:justify-items-center'>
      <OrangeDivider className='w-12 h-1 mb-3' />
      <h4 className='group-header sm:text-center'>
        Do you have any best practices for online ministry?
      </h4>
      <div className='mt-2 body-paragraph sm:text-center'>
        Yes! Watch, read, or download resources to help you build a successful online ministry.
      </div>
      <div className='mt-6 mb-16 sm:mb-24 lg:mb-32'>
        <AngleButton text='Keep Learning' link='learn' />
      </div>
    </div>
  );
};

export default BestPractices;
